import React from "react";
import { Card, KeyValueList, ValueOrPlaceholder } from "@sscs/ui";
import styles from "./signatureMetadata.module.scss";
import ValidationIcon from "./ValidationIcon";
const SignatureMetadata = ({ signature, title, }) => {
    return (React.createElement(Card.Card, { className: styles.signature },
        React.createElement(Card.Title, null,
            React.createElement("div", { className: styles.title },
                title,
                React.createElement(ValidationIcon, { isValid: signature.signature.valid }))),
        React.createElement(Card.Content, null, React.createElement(KeyValueList, { list: {
                Timestamp: React.createElement(ValueOrPlaceholder, { value: signature.timestamp }),
                Validation: signature.signature.scan_results.results.length > 0 ? (React.createElement(React.Fragment, null, signature.signature.scan_results.results.map((result) => (React.createElement("div", { key: result }, result))))) : ("Valid"),
            } }))));
};
export default SignatureMetadata;
//# sourceMappingURL=SignatureMetadata.js.map